export const contentTypesLearnMoreHtml = (words, availableTypes, notAvailableTypes) => {
  return `
    <h4 class="small-top-buffer">Content Types at ${words.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} Words</h4>
    <hr class="brand-hr">
  ` +
  '<p>' +
  {
    300: `Good length for just getting started and keeping your blog current, especially in niche and hyper-local businesses.`,
    600: `Excellent option for companies ready to grow their presence in mid-sized markets or emerging niches.`,
    1000: `Perfect for establishing your company as a content leader and optimizing SEO potential.`,
    1500: `Best for building awareness and an impactful, high-quality content presence in markets with lots of competition.`,
    2000: `Ideal for creating pillar content, Ebooks, and other forms of content that will serve as thought leadership in your industry.`
  }[words] +
  '</p>' +
  `
    <h5>Available:</h5>
    <p style="white-space: pre-wrap">${availableTypes}</p>
    <h5>Not Available:</h5>
    <p style="white-space: pre-wrap">${notAvailableTypes}</p>
  `
}

export const addonLearnMoreHtml = (addon, photos) => {
  return `
    <h4>${ page[addon].title }</h4>
    <p class="h4-subheader">${ page[addon].subtitle(photos) }</p>
    <hr class="brand-hr">
    ${page[addon].descriptionHTML(photos)}
  `
}

const page: object = {
  basic: {
    title: 'Verblio Basic',
    subtitle: (n) => 'Top-notch content, full access to Verblio platform',
    descriptionHTML: (n) => `
      <p>
      Verblio's core service creates top-notch content. You'll have full access to the Verblio platform and network of writers.
      </p>
      <p>
      Includes: great content, unlimited edits, built-in publishing tools, and helpful support from the Verblio team.
      </p>
      <p>
        <ul>
          <li>Use the Verblio platform to create content requests, set deadlines, find great writers, and only buy the content you like.</li>
          <li>Publish fast with simple WordPress & HubSpot integrations.</li>
          <li>Get help from Verblio's friendly content specialists.</li>
        </ul>
      </p>
    `
  },
  plusPhoto: {
    title: '+Photo',
    subtitle: (photosPerPost) => 'Verblio Basic & hand-selected stock photo(s)',
    descriptionHTML: (photosPerPost) => `
      <p class="bottom-buffer">
        Save time and get more from the content you buy.
      </p>
      <p>
        Includes everything from Verblio Basic, plus:
      </p>
      <p>
        <ul>
          <li>High-quality stock photography.</li>
          <li>Copyright-secured, royalty-free images.</li>
          <li>Receive within 1 business day after accepting a piece of content.</li>
          <li>Helpful tags and captions.</li>
        </ul>
      </p>
    `
  },
  plusOptimize: {
    title: '+ Optimize*',
    subtitle: (photosPerPost) => 'Content, hand-selected photo(s) & SEO optimization',
    descriptionHTML: (photosPerPost) => `
    <p>
      Save time and resources—stay high-level while we handle the details.
    </p>
    <p>
      Includes everything from Verblio Basic and +Photo, plus:
    </p>
    <ul>
      <li>
        <p>SEO optimization for every piece, including focus keyword and related keyword incorporation (if provided), meta description, image alt-tagging, URL, and header optimization.</p>
      </li>
      <li>
        <p>Extra round of proofreading.</p>
      </li>
      <li>
        <p>Formatting and scheduling in your CMS (or via Google doc, if preferred).</p>
      </li>
    </ul>
    `
  },
  verblioComplete: {
    title: 'Verblio Complete',
    subtitle: (n) => 'Fully-managed service with a dedicated account manager',
    descriptionHTML: (n) => `
    <p>
      Verblio Complete will transform our self-service platform for buying top-notch content
      into a <b>fully-managed service</b> for executing <b>your existing content strategy</b>.
    </p>
    <p>
      You'll benefit from all features of Verblio Basic, +Photo, and +Optimize, AND we'll pair
      you with a Hubspot Inbound-certified account manager, who will serve as your <b>dedicated
      point-person</b> and advocate in the system.
    </p>
    <p>
      Your AM will make sure you have:
    </p>
    <ul>
      <li>
        <p>Personalized onboarding & regular check-in calls</p>
      </li>
      <li>
        <p>A customized workflow that best suits you and your team's needs—as hands-on or hands-off as you like </p>
      </li>
      <li>
        <p>A dedicated point of contact for all support questions</p>
      </li>
      <li>
        <p>Expert management of the Verblio platform to ensure high-quality content, with guidance on generating topics
        and strong requests, developing writer relationships, and reviewing submissions</p>
      </li>
      <li>
        <p>Our complete content-optimization workflow, including professional edits & proofreading, adherence to SEO
        best practices, hand-picked stock image(s), and content delivery according to your preferences</p>
      </li>
    </ul>
    <p>Don't have a content strategy yet? Add our Content Strategy package after you select your plan in sign-up.</p>
    `
  }
}
